/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NodeItem } from '../../models/node-item';

export interface ApiV0NodeitemGetNodeItemByIdGet$Plain$Params {
  id?: string;
}

export function apiV0NodeitemGetNodeItemByIdGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0NodeitemGetNodeItemByIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<NodeItem>> {
  const rb = new RequestBuilder(rootUrl, apiV0NodeitemGetNodeItemByIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NodeItem>;
    })
  );
}

apiV0NodeitemGetNodeItemByIdGet$Plain.PATH = '/api/v0/nodeitem/getNodeItemById';
